import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import ConfigurationActions from '../../redux/configurationRedux';
import PartsActions from '../../redux/partsRedux';
import { isNil } from '../../services/helper';
import style from '../scenes.scss';
import interiorStyle from './interior.scss';

// Components
import InteriorButton from '../../components/interior/interiorButtonComponent';
import CaravanInsideImage from '../../components/caravan/caravanImage/caravanInsideImageComponent';
import InteriorBox from '../../components/selectionBoxes/interiorBox/interiorBoxComponent';
import SceneNotice from '../../components/notice/sceneNoticeComponent';
import resolvePrice from '../../services/helper/resolvePrice';
import checkMarkedDependency from '../../services/helper/checkMarkedDependency';

class InteriorScene extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showInteriorSelectionScreen: false,
            selectedCategory: null,
        };
    }

    componentWillMount() {
        this.listItems();
    }

    listItems = () => {
        const { listPartsRequest, parts, configuration } = this.props;
        if (isNil(parts.decors) || configuration.refreshing) {
            listPartsRequest('all', configuration.model.id);
            this.props.setRefreshing(false);
        }
    }

    checkIsDone = (category) => {
        const { configuration } = this.props;
        let isDone = false;
        for (let i = 0; i < configuration.configurations.interior.length; i += 1) {
            if (configuration.configurations.interior[i].category === category) {
                isDone = true;
            }
        }
        return isDone;
    }

    onSelectItem = (interior, closeWindow = true) => {
        const { configuration, updateConfiguration, parts } = this.props;
        if (!isNil(interior)) {
            let selectedItems = [...configuration.configurations.interior];
            selectedItems = selectedItems.filter(item => (
                item.category !== interior.category
            ));

            selectedItems.push(interior);
            updateConfiguration('interior', selectedItems, parts);
            if (closeWindow) {
                this.setState({ showInteriorSelectionScreen: false });
            }
        }
    }

    onSelectCategory = (category) => {
        this.setState({ selectedCategory: category, showInteriorSelectionScreen: true });
    }

    resolvePrice = (part, serialParentUid) => resolvePrice(
        part, serialParentUid, this.props.configuration.configurations
    );

    renderInteriorItems = () => {

        const { selectedCategory } = this.state;
        const { configuration, parts } = this.props;

        const selectedItems = configuration.configurations.interior.filter(item => (
            item.category === selectedCategory
        ));

        const interiorItems = parts.decors.data.filter(item => (
            item.category === selectedCategory
        ));

        const listItems = interiorItems.map((interiorItem) => (
            <InteriorBox
                key={interiorItem.uid}
                item={interiorItem}
                selectedItems={selectedItems}
                onSelectItem={(item, closeWindow) => this.onSelectItem(item, closeWindow)}
                markedDependencies={configuration.markedDependencies}
                resolvePrice={this.resolvePrice}
            />
        ));

        let hasMarkedDependency = false;
        hasMarkedDependency = checkMarkedDependency(
            parts.decors.data,
            configuration.markedDependencies
        );

        return (
            <div className={style.form_container_4}>
                {
                    hasMarkedDependency ?
                        <SceneNotice content={t`Sie haben nun die Möglichkeit Ihre Konfiguration zu ändern. Eine Änderung kann ggf. Auswirkungen auf die bestehende Konfiguration haben. Bitte prüfen Sie die folgenden Einstellungen!`} />
                        : null
                }
                {listItems}
            </div>
        );
    }

    render() {
        const { selectedCategory } = this.state;
        const { configuration, parts, fetching } = this.props;
        if (fetching === null || fetching === true) {
            return (
                <h2>{t`LADE`}</h2>
            );
        }

        const selectedItems = configuration.configurations.interior;
        const interiorItems = parts.decors.data;
        for (let i = 0; i < interiorItems.length; i += 1) {
            if (!interiorItems[i].preselected && !interiorItems[i].mandatory) {
                continue; // eslint-disable-line no-continue
            }
            if (selectedItems.reduce(
                (b, item) => b || item.category === interiorItems[i].category, false)
            ) {
                break;
            }

            this.onSelectItem(interiorItems[i], false);
        }

        interiorItems.map((interiorItem) => {
            if (configuration.markedDependencies.indexOf(interiorItem.uid) > -1) {
                if (!selectedCategory) {
                    this.onSelectCategory(interiorItem.category);
                }
            }
            return null;
        });

        if (this.state.showInteriorSelectionScreen) {
            return (
                <div className={style.scene}>
                    <div className={style.title}>
                        <h2>{t`Innenraum gestalten`}</h2>
                    </div>
                    <form>
                        {this.renderInteriorItems()}
                    </form>
                </div>
            );
        }
        return (
            <div className={style.scene}>
                <div className={style.title}>
                    <h2>{t`Innenraum gestalten`}</h2>
                </div>
                <div className={style.container}>
                    <CaravanInsideImage />
                    <div className={`sky_${this.props.locale} ${interiorStyle.sky}`}>
                        <InteriorButton
                            label={t`Himmel`}
                            category="roof_lining"
                            isDone={this.checkIsDone('roof_lining')}
                            onSelect={(category) => this.onSelectCategory(category)}
                        />
                    </div>
                    <div className={interiorStyle.corpus}>
                        <InteriorButton
                            label={t`Korpus`}
                            category="decor"
                            isDone={this.checkIsDone('decor')}
                            onSelect={(category) => this.onSelectCategory(category)}
                        />
                    </div>
                    <div className={interiorStyle.upholstery}>
                        <InteriorButton
                            label={t`Polster`}
                            category="padding_cover"
                            isDone={this.checkIsDone('padding_cover')}
                            onSelect={(category) => this.onSelectCategory(category)}
                        />
                    </div>
                    <div className={interiorStyle.fronts}>
                        <InteriorButton
                            label={t`Fronten`}
                            category="fold"
                            isDone={this.checkIsDone('fold')}
                            onSelect={(category) => this.onSelectCategory(category)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    locale: state.locale,
    caravans: state.caravans.caravans,
    parts: state.parts.parts,
    fetching: state.parts.fetching,
    configuration: state.configuration,
});

const mapDispatchToProps = dispatch => ({
    updateConfiguration: (category, value, parts) =>
        dispatch(ConfigurationActions.updateConfiguration(category, value, parts)),
    listPartsRequest: (category, identifier) =>
        dispatch(PartsActions.listPartsRequest(category, identifier)),
    setRefreshing: (refresh) =>
        dispatch(ConfigurationActions.setRefreshing(refresh)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InteriorScene);
